'use strict';

const toPathComponents = function (path) {
  if (path === void 0) {
    path = '';
  }
  // split on / unless escaped with \
  return (path.trim().match(/([^\\^/]|\\\/)+/g) || []).filter(Boolean);
};
module.exports = toPathComponents;